export const URL = {
  APP_STORE: 'https://apps.apple.com/us/app/life-organized/id1531585154',
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=app.lifeorganized',
};
